import { Component, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DataContext } from '@services/data-context';
import { ViewportService } from '@services';
import { ConfirmationModalComponent } from '@modals';
import { CompanySelectionModalComponent } from './pages/company-selection';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ConfirmationModalComponent, CompanySelectionModalComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  host: {
    '(window:resize)': 'onWindowResize()'
  }
})
export class App {
  private readonly dataContext = inject(DataContext);
  private readonly translate = inject(TranslateService);
  private readonly viewportService = inject(ViewportService);

  constructor() {
    this.translate.addLangs(['no', 'se', 'en', 'da', 'fi']);
    this.translate.setFallbackLang('no');
    this.translate.use('no');

    effect(() => {
      const user = this.dataContext.loggedInUser();
      if (user?.language) {
        this.translate.use(user.language);
      }
    });
  }

  protected onWindowResize(): void {
    if (globalThis.window === undefined) {
      return;
    }
    this.viewportService.updateWidth(globalThis.window.innerWidth);
  }
}
